/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { acceptedLanguages } from "..";

export const Translated = ({ children }: { children: React.ReactNode }) => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const userBrowserLanguage = navigator.language.split("-")[0];

    if (acceptedLanguages.includes(userBrowserLanguage)) {
      i18n.changeLanguage(userBrowserLanguage);
    }
  }, [i18n.changeLanguage]);

  return children;
};
